export default __webpack_public_path__ + "img/right-arrow.9a693ca7.svg";